import { Bestellung, RemoteResult, IdRequest, LoadState } from "mangdto"
import router from "@/router"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"

export default class BezahlenBestaetigtLogic extends BaseLogic {
  bestellung?: Bestellung = null

  bestellungLoadState: LoadState = LoadState.Idle
  bezahlungAbschliessenLoadState: LoadState = LoadState.Idle

  init(id: string) {
    this.bestellung = this.mainLogic.bestellung

    this.bestellungLoadState = LoadState.Loading

    var request = new IdRequest()
    request.id = id

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungKundeDetails,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.bestellungLoadState = LoadState.Completed
          this.bestellung = response.data.payload
          this.bezahlungAbschliessen()
        } else {
          this.bestellungLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.bestellungLoadState = LoadState.Error
      })
  }

  bezahlungAbschliessen() {
    this.bezahlungAbschliessenLoadState = LoadState.Loading

    var request = new IdRequest()
    request.id = this.bestellung.id

    Poster.postUser<RemoteResult<any>>(
      RestPaths.paymentPaypalAbschliessen,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.bezahlungAbschliessenLoadState = LoadState.Completed
          router.push({
            name: RouteNames.BESTELLUNG_PAGE.DETAILS,
            params: { bestellungId: this.bestellung.id },
          })
        } else {
          this.bezahlungAbschliessenLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.bezahlungAbschliessenLoadState = LoadState.Error
      })
  }

  zurBestellung() {
    router.push({
      name: RouteNames.BESTELLUNG.DETAILS,
      params: { id: this.bestellung.id },
    })
  }
}
